import { useCallback, useMemo, useReducer } from 'react';
import { Meta, State, Config, Actions } from './types';
import { getPaginationMeta } from './meta';
import { reducer } from './reducer';

export const usePagination = ({
  totalItems = 0,
  initialPage = 0,
  initialPageSize = 0,
}: Config = {}): State & Meta & Actions => {
  const initialState = {
    totalItems,
    pageSize: initialPageSize,
    currentPage: initialPage,
  };

  const [paginationState, dispatch] = useReducer(reducer, initialState);

  return {
    ...paginationState,
    ...useMemo(() => getPaginationMeta(paginationState), [paginationState]),
    setTotalItems: useCallback((totalItems: number) => {
      dispatch({ type: 'SET_TOTAL_ITEMS', totalItems });
    }, []),
    setPage: useCallback((page: number) => {
      dispatch({
        type: 'SET_PAGE',
        page,
      });
    }, []),
    setNextPage: useCallback(() => {
      dispatch({ type: 'NEXT_PAGE' });
    }, []),
    setPreviousPage: useCallback(() => {
      dispatch({ type: 'PREVIOUS_PAGE' });
    }, []),
    setPageSize: useCallback((pageSize: number, nextPage = 0) => {
      dispatch({ type: 'SET_PAGE_SIZE', pageSize, nextPage });
    }, []),
  };
};
